import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

import { toastMessage } from "../../../utils/toast";
import * as paymentActions from "../../../Redux/Actions/payment";
import * as refundActions from "../../../Redux/Actions/refunds";
import { getLocaleValue } from "../../../utils";
import { clearSession } from "../../../utils/initiate";

export default function RefundModal({
  showModal,
  loading,
  handleCancel,
  handleOk,
  history,
  match,
  footerOption1,
  footerOption2,
  type,
  setDescription,
  setReasonId,
  reasonId,
  description,
  setConfirmModal,
  t,
}) {
  const dispatch = useDispatch();
  const [errMsg, setErrMsg] = useState("");
  const [buttonLoading, setButtonLoading] = useState("");
  const [condition, setCondition] = useState(false);
  const [descriptionError, setDescriptionError] = useState("");
  // const [reasonId, setReasonId] = useState(0);
  const [dropDownItems, setDropDownItems] = useState([]);
  // const [description, setDescription] = useState("");
  const { jobID } = match.params;

  useEffect(() => {
    refundActions
      .getAllPaymentRefundReasons()
      .then((res) => {
        if (res?.data) {
          // console.log(res.data);
          let dropdownDetails = res.data.map(({ id, localizationKeys }) => {
            return { id, name: JSON.parse(localizationKeys)?.name };
          });
          setDropDownItems(dropdownDetails);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          clearSession(dispatch, history);
          toastMessage("error", `Access Denied`);
        } else {
          toastMessage("error", `Unable to get refund Details `);
        }
      });
  }, []);

  const handleSubmit = () => {
    if (condition && reasonId) {
      console.log(reasonId != 6);
      console.log(reasonId !== 6);
      if (reasonId == 6 && description == "") {
        setDescriptionError("Please enter the reason in brief");
      } else {
        handleOk();
      }
    } else {
      setErrMsg(getLocaleValue("Please fill all required field"));
    }
  };

  return (
    <div>
      <div
        className="modal"
        style={{
          display: showModal ? "block" : "",
          alignItems: "center",
          top: "10%",
        }}
      >
        <div className="modal-dialog" style={{ maxWidth: "600px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 style={{ color: "white" }}></h5>
              <button
                type="button"
                className="close p-1 rounded"
                aria-label="Close"
                onClick={handleCancel}
                style={{ border: "none" }}
              >
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              {type === "refund" ? (
                <div>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {getLocaleValue("refund_header1")}
                  </div>
                  <div
                    style={{
                      fontWeight: "500",
                      textAlign: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Please let us know few things for payment refund
                    </span>
                  </div>

                  <select
                    className="form-select"
                    value={reasonId}
                    onChange={(e) => {
                      setReasonId(e.target.value);
                      setDescriptionError("");
                    }}
                    style={{
                      width: "53%",
                      height: "35px",
                      marginBottom: "10px",
                    }}
                  >
                    <option className="font-17" value={0} key={0}>
                      {getLocaleValue("select")}
                    </option>
                    {dropDownItems
                      ? dropDownItems.map((item) => {
                          return (
                            <option
                              className="font-17"
                              value={item.id}
                              key={item.id}
                            >
                              {getLocaleValue(item.name)}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                  {/* <label class="form-check-label" htmlFor="description">
                    {getLocaleValue("due_payment_description_label")}
                  </label> */}
                  <textarea
                    className="form-control"
                    type="text-area"
                    required={true}
                    value={description}
                    name="description"
                    id="description"
                    onChange={(e) => {
                      setDescription(e.target.value);
                      setDescriptionError("");
                    }}
                    placeholder={"State your concerns"}
                  />
                  {descriptionError && (
                    <p className="text-danger text-center">
                      {descriptionError}
                    </p>
                  )}
                  <div
                    class="form-check"
                    style={{ marginLeft: "15px", marginTop: "20px" }}
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      required={true}
                      checked={condition}
                      value=""
                      id="defaultCheck1"
                      onClick={(e) => {
                        setCondition(e.target.checked);
                      }}
                      onChange={() => {
                        setErrMsg("");
                      }}
                    />
                    <label class="form-check-label">
                      <a
                        href="https://aamergroup.ae/home/refund_policy"
                        target={"_blank"}
                        style={{
                          mariginTop: "20px",
                          textDecoration: "underline",
                        }}
                      >
                        {" "}
                        I have read & accepted terms & conditions{" "}
                      </a>
                    </label>
                  </div>
                </div>
              ) : (
                <div>
                  <div>
                    <label> Contact Us +97126519000 </label>
                  </div>
                  <a href="mailto:support@aamergroup.ae">
                    Email Us support@aamergroup.ae
                  </a>
                </div>
              )}
            </div>

            {errMsg && <p className="text-danger text-center">{errMsg}</p>}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light-danger font-weight-bold"
                onClick={handleCancel}
              >
                {footerOption2 ? footerOption2 : "Cancel"}
              </button>
              <button
                type="button"
                className="btn btn-primary font-weight-bold d-flex align-items-center"
                onClick={handleSubmit}
                disabled={buttonLoading}
              >
                {footerOption1 ? footerOption1 : "Submit"}
                {buttonLoading && (
                  <Loader
                    type="Oval"
                    color="#fff"
                    height={20}
                    width={20}
                    style={{ marginLeft: "10px" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </div>
  );
}
